import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"]
})
export class LoginComponent {
	public brand = BrandVars;
	email = "";
	password = "";

	errormessage?: string;

	constructor(public router: Router, private api: ApiService) { }

	Login() {
		this.errormessage = undefined;
		this.api.Login(this.email, this.password, true).then(() => {
			this.router.navigate(["dash"]);
		}).catch(err => {
			if (err && err.status && err.status === 401) {
				this.errormessage = "Invalid username or password";
			} else {
				this.errormessage = "Login failed";
			}
		});
	}
}
